import React, {useEffect, useState} from 'react';
import {Trans} from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import {toast} from 'react-toastify';
import skincareProDao from '../../../../../dao/skincareProDao';
import {useSelector} from 'react-redux';
import FormattedDate from '../../../../../components/product/FormattedDate';
import ManualDataTable from '../../../../../components/manualdatatable/ManualDatatable';
import {getCategory, mapCategories} from '../../../../../utils/skincareUtils';
import _get from 'lodash/get';
import utils from '../../../../../utils/smbUtils';

export default function ViewProductModal({
  editId,
  showModal,
  handleCloseModel,
}) {
  const [categoryMapping, setCategoryMapping] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [processedParams, setProcessedParams] = useState(null);
  const [editData, setEditData] = useState({
    results: [],
    totalSize: 0,
  });
  const {token, customerId} = utils.customerInfo(
    useSelector(state => state.components.auth.accountSummary)
  );

  useEffect(() => {
    if (!showModal) {
      return;
    }
    getCategory(token, customerId, 'Skincare').then(resCategory => {
      setCategoryMapping(mapCategories(resCategory));
    });
  }, []);

  const getEditedRoutineAPI = async productId => {
    const tmp = new FormData();
    tmp.append('token', token);
    tmp.append('customerId', customerId);
    tmp.append('productIds', productId);
    tmp.append('showDataAndFiles', true);
    tmp.append('showProductRefs', true);
    const res = await skincareProDao.getGenericInfo(tmp);

    if (res) {
      const transformedData = res[0].productRefs.map(item => {
        return {
          id: item.product.id,
          categoryId: item.product.categoryIds,
          name: item.product.name,
          imageUrl: item.product.imageUrl,
          createdTime: item.product.createdTime,
          lastModified: item.product.lastModified,
          status: item.product.status,
        };
      });

      const displayArray = res[0].data.productRefs;

      const transformedDataWithDisplayOrder = transformedData.map(item => {
        const displayOrder = displayArray.find(
          displayItem => displayItem.referencedProduct.id === item.id
        ).displayOrder;
        return {
          ...item,
          displayOrder,
        };
      });
      setEditData({
        ...editData,
        results: transformedDataWithDisplayOrder,
        totalSize: _get(res, 'totalSize', 0),
      });
      setIsLoading(false);
      return;
    }
    toast.error(
      <Trans i18nKey="toast.error.loading.data.failed">
        Loading Data Failed
      </Trans>
    );
    setIsLoading(false);
  };

  useEffect(() => {
    if (!processedParams) {
      return;
    }
    setIsLoading(true);
    getEditedRoutineAPI(editId);
  }, [processedParams]);

  const columns = [
    {
      accessor: 'displayOrder',
      disableSortBy: true,
      style: {width: '10%'},
    },
    {
      Header: <Trans i18nKey="p.s.listskincareroutine.image">Image</Trans>,
      accessor: 'imageUrl',
      disableSortBy: true,
      style: {width: '10%', textAlign: 'center'},
      Cell: ({cell: {value}}) => (
        <img
          alt=""
          src={value}
          style={{height: '50px', display: 'block', margin: '0 auto'}}
        />
      ),
    },
    {
      Header: (
        <Trans i18nKey="p.s.listskincareroutine.category">Category</Trans>
      ),
      accessor: 'categoryId',
      disableSortBy: true,
      style: {width: '15%', textAlign: 'center'},
      Cell: ({cell: {value}}) => categoryMapping[value],
    },
    {
      Header: (
        <Trans i18nKey="p.s.listskincareroutine.product.Name">
          Product Name
        </Trans>
      ),
      disableSortBy: true,
      accessor: 'name',
      style: {width: '12.5%', textAlign: 'center', wordBreak: 'break-word'},
    },
    {
      Header: (
        <Trans i18nKey="p.s.listskincareroutine.creation">Creation</Trans>
      ),
      accessor: 'createdTime',
      disableSortBy: true,
      style: {width: '12.5%', textAlign: 'center'},
      Cell: ({cell: {value}}) => (
        <div className="text-right">
          <FormattedDate time={value} type={'long'} />
        </div>
      ),
    },
    {
      Header: (
        <Trans i18nKey="p.s.listskincareroutine.modification">
          Modification
        </Trans>
      ),
      accessor: 'lastModified',
      disableSortBy: true,
      style: {width: '12.5%', textAlign: 'center'},
      Cell: ({cell: {value}}) => (
        <div className="text-right">
          <FormattedDate time={value} type={'long'} />
        </div>
      ),
    },
  ];

  return (
    <Modal
      centered
      show={showModal}
      onHide={() => {
        setEditData({
          ...editData,
          results: [],
          totalSize: 0,
        });
        handleCloseModel(false);
      }}
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <Trans i18nKey="p.s.listskincareroutine.view.routine.detail">
            View Routine Detail
          </Trans>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ManualDataTable
          isLoading={isLoading}
          columns={columns}
          data={editData.results}
          totalSize={editData.totalSize}
          initState={{
            sortBy: {id: 'displayOrder', desc: false},
            pageSize: 5,
            pageIndex: 1,
            hiddenColumns: ['displayOrder'],
          }}
          setProcessedParams={setProcessedParams}
          isScrollX={true}
        />
      </Modal.Body>
      <Modal.Footer className="text-right">
        <div className="d-flex justify-content-end flex-fill">
          <div className="text-center margin-top-10">
            <div
              className="btn btn-outline-secondary kt-margin-r-10 kt-margin-b-10 cursor-pointer"
              onClick={() => {
                setEditData({
                  ...editData,
                  results: [],
                  totalSize: 0,
                });
                handleCloseModel(false);
              }}
            >
              <Trans i18nKey="p.s.listskincareroutine.close">Close</Trans>
            </div>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
